<div [ngSwitch]="currentStepIndex" class="modal">
<div *ngSwitchCase="0">
      <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }">

        <div nz-col nzSpan="18">
          <div>
            <div class="title">
              <div>{{'moniepoint.enter'|translate}} OTP</div>
            </div>
            <div class="sub-title">
              <p>
                {{otpResponse?.message}}</p>
            </div>

            <div *ngIf="otpResponse.ussdCode" class="sub-title m-t-10 m-b-10">
              <span class="m-t-9">or dial <a href="{{'tel:' + otpResponse?.ussdCode}}"><span class="fa fa-phone"></span>{{otpResponse?.ussdCode}}</a></span>
<!--              <p class="m-t-9">-->
<!--                {{'or dial'}}{{" "}}{{otpResponse?.ussdCode}}</p>-->
            </div>

          </div>
        </div>

        <div nz-col nzSpan="24">
          <form nz-form [formGroup]="otpForm" autocomplete="off">
            <nz-form-item>
              <nz-form-control nzErrorTip="Enter valid OTP">
          <nz-input-group class="custom-modal-body-content-spacing">
            <input formControlName="otp" type="text" nz-input placeholder="{{'moniepoint.enter'|translate}} OTP" />
          </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </form>
        </div>

        <div nz-col nzSpan="24" *ngIf="countDown">
          <div nz-row>
            <div nz-col nzSpan="8">
              <div class="otp-countdown-container">
                <h6 class="otp-countdown" translate>moniepoint.time_remaining</h6>
              </div>
            </div>
            <div nz-col nzSpan="12">
              <div class="otp-countdown-container">
                <nz-countdown [nzValueStyle]="{lineHeight: '15px',fontSize:'14px',color:'#0361F0'}"
                              [nzValue]="deadline" [nzFormat]="'mm:ss'"></nz-countdown>
              </div>
            </div>
          </div>
        </div>

        <div nz-col nzSpan="24" *ngIf="!countDown">
          <div align="right">
            <div class="otp-resend">
              <a (click)="resendOtp()">{{'moniepoint.resend'|translate}} OTP</a>
            </div>
          </div>
        </div>

        <div nz-col nzSpan="24">
          <app-custom-error-display [errorMessage]="errorMessage"></app-custom-error-display>
        </div>

        <div nz-col nzSpan="24">
          <div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32 }" class="m-t-20">
            <div nz-col class="gutter-row" [nzSpan]="12">
              <button [disabled]="loadingButton" class="btn btn-secondary btn-block"
                      (click)="cancel()">{{'moniepoint.cancel'|translate}}</button>
            </div>

            <div nz-col class="gutter-row" [nzSpan]="12">
              <app-custom-submit-button [disabled]="!otpForm.valid"
                                        [submitting]="loadingButton" [block]="true" name="Submit"
                                        (click)="submitOtp()">
              </app-custom-submit-button>
            </div>
          </div>
        </div>

      </div>
    </div>

  <div *ngSwitchDefault>
    <app-loading [loadingText]="loadingText|translate"></app-loading>
  </div>

  </div>
